import { render, staticRenderFns } from "./SearchCollections.vue?vue&type=template&id=2c1a8a5f&scoped=true&"
import script from "./SearchCollections.vue?vue&type=script&lang=ts&"
export * from "./SearchCollections.vue?vue&type=script&lang=ts&"
import style0 from "./SearchCollections.vue?vue&type=style&index=0&id=2c1a8a5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1a8a5f",
  null
  
)

export default component.exports